import Cookies from "js-cookie";
import store from "@/store";
import VueI18n from "vue-i18n";
import Vue from "vue";

import {enumDef} from "@/common/enumDefs";

Vue.use(VueI18n);

if (!Cookies.get("language")) {
	Cookies.set("language", enumDef.language.DE)
}

const localization = {
	currentLang: currentLang,
	currentLocale: currentLocale,

	i18n: new VueI18n(
	{
		locale: currentLang(),
		messages: loadTranslations()
	})
};

function currentLang() {
	return Cookies.get("language") || store.state.base.currentLang;
}

function currentLocale() {
	return currentLang().substring(0, currentLang().indexOf("_"));
}

function loadTranslations() {
	const legalStructures = require("./independent/legalStructures.json");
	const registerCourts = require("./independent/registerCourts.json");

	let translations = {
		"KEY_zh": {}
	};

	for (let langKey in enumDef.language.properties) {
		translations[langKey] = {
			...require("./" + enumDef.language.properties[langKey].file),
			...legalStructures,
			...registerCourts
		};
	}

	return translations;
}

export {
	localization
};